function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// src/components/progress.ts
import { progressAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/styled-system";
import { generateStripe, getColor, mode } from "@chakra-ui/theme-tools";
var _createMultiStyleConf = createMultiStyleConfigHelpers(parts.keys),
  defineMultiStyleConfig = _createMultiStyleConf.defineMultiStyleConfig,
  definePartsStyle = _createMultiStyleConf.definePartsStyle;
var filledStyle = defineStyle(function (props) {
  var c = props.colorScheme,
    t = props.theme,
    isIndeterminate = props.isIndeterminate,
    hasStripe = props.hasStripe;
  var stripeStyle = mode(generateStripe(), generateStripe("1rem", "rgba(0,0,0,0.1)"))(props);
  var bgColor = mode("".concat(c, ".500"), "".concat(c, ".200"))(props);
  var gradient = "linear-gradient(\n    to right,\n    transparent 0%,\n    ".concat(getColor(t, bgColor), " 50%,\n    transparent 100%\n  )");
  var addStripe = !isIndeterminate && hasStripe;
  return _objectSpread(_objectSpread({}, addStripe && stripeStyle), isIndeterminate ? {
    bgImage: gradient
  } : {
    bgColor: bgColor
  });
});
var baseStyleLabel = defineStyle({
  lineHeight: "1",
  fontSize: "0.25em",
  fontWeight: "bold",
  color: "white"
});
var baseStyleTrack = defineStyle(function (props) {
  return {
    bg: mode("gray.100", "whiteAlpha.300")(props)
  };
});
var baseStyleFilledTrack = defineStyle(function (props) {
  return _objectSpread({
    transitionProperty: "common",
    transitionDuration: "slow"
  }, filledStyle(props));
});
var baseStyle = definePartsStyle(function (props) {
  return {
    label: baseStyleLabel,
    filledTrack: baseStyleFilledTrack(props),
    track: baseStyleTrack(props)
  };
});
var sizes = {
  xs: definePartsStyle({
    track: {
      h: "1"
    }
  }),
  sm: definePartsStyle({
    track: {
      h: "2"
    }
  }),
  md: definePartsStyle({
    track: {
      h: "3"
    }
  }),
  lg: definePartsStyle({
    track: {
      h: "4"
    }
  })
};
var progressTheme = defineMultiStyleConfig({
  sizes: sizes,
  baseStyle: baseStyle,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
});
export { progressTheme };